import { Component } from 'react';
import { connect } from 'react-redux';
import { lockWithPreviewUnlessHasAny } from '../lockDecorators';
import SpinnerOverlay from '../SpinnerOverlay';
import { selectClassroom } from '../Classrooms';
import MoodboardComponent from '../AdministratorDashboard/MoodboardComponent';

const mapStateToProps = (state) => ({
  classroom: selectClassroom(state),
  userProfile: state.user.userProfile,
});

class MoodBoardPage extends Component {
  render() {
    if (!this.props.userProfile || !this.props.classroom) {
      return <SpinnerOverlay isShow />;
    }

    return <MoodboardComponent classroomId={this.props.classroom.classroomId} userId={this.props.userProfile.userId} />;
  }
}

export default connect(
  mapStateToProps,
  null,
)(lockWithPreviewUnlessHasAny('KEY_MOODBOARD', 'KEY_PEEKAPAK_MANAGEMENT', 'KEY_WIP', 'KEY_MASTER_KEY')(MoodBoardPage));
